var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetCustomerApi, useGetFamilyApi, useGetPersonApi, useGetFamilyPlanPreferencesApi, useUpdateFamilyPlanPreferencesApi, } from '../../hooks';
import { isFamilyMemberMinor, isFamilyMemberRegisterRequested, } from '../../redux';
import { useFamilyMemberComposer } from './useFamilyMemberComposer.facade';
import { useUpdateProfileHelper } from './helpers/useUpdateProfileHelper';
import { isLowFodmapDisabledBySoy, } from './helpers/planPreferences.utils';
var EMPTY_PREFERENCES = {
    lowFodmap: false,
    lowBudget: false,
    lunchbox: false,
};
export var useInputPlanPreferencesFormFacade = function (_a) {
    var onNext = _a.onNext, personId = _a.personId, _b = _a.isFamilyMemberUpdate, isFamilyMemberUpdate = _b === void 0 ? false : _b, confirmAlert = _a.confirmAlert, source = _a.source;
    //** REDUX **//
    var isNewFamilyMember = useSelector(isFamilyMemberRegisterRequested);
    var isFamilyMember = isNewFamilyMember || isFamilyMemberUpdate;
    var isMinor = useSelector(isFamilyMemberMinor);
    var _c = useState(EMPTY_PREFERENCES), preferences = _c[0], setPreferences = _c[1];
    // Stato "salvato" di riferimento per il dirty-check del bottone Salva.
    var baselineRef = useRef(EMPTY_PREFERENCES);
    var profile = useFamilyMemberComposer().profile;
    //** API **//
    var customer = useGetCustomerApi(!isFamilyMember).data;
    var person = useGetPersonApi(personId || (customer === null || customer === void 0 ? void 0 : customer.personId)).data;
    var familyId = person === null || person === void 0 ? void 0 : person.familyId;
    var family = useGetFamilyApi(familyId).data;
    var savedPreferences = useGetFamilyPlanPreferencesApi(familyId).data;
    var updateFamilyPlanPreferences = useUpdateFamilyPlanPreferencesApi().updateFamilyPlanPreferences;
    var updateProfile = useUpdateProfileHelper({
        isFamilyMember: isNewFamilyMember,
        person: person,
        customer: customer,
        callFamilyUpdateApi: true,
    }).updateProfile;
    var labelsConjugationCondition = !isFamilyMember && (customer === null || customer === void 0 ? void 0 : customer.personId) === (person === null || person === void 0 ? void 0 : person.id);
    useEffect(function () {
        if (savedPreferences) {
            baselineRef.current = savedPreferences;
            setPreferences(savedPreferences);
        }
    }, [savedPreferences]);
    var lowFodmapDisabled = useMemo(function () {
        var _a;
        var members = __spreadArray(__spreadArray([], ((_a = family === null || family === void 0 ? void 0 : family.Person) !== null && _a !== void 0 ? _a : []), true), [
            { commonAllergies: person === null || person === void 0 ? void 0 : person.commonAllergies },
            { commonAllergies: profile === null || profile === void 0 ? void 0 : profile.commonAllergies },
        ], false);
        return isLowFodmapDisabledBySoy(members);
    }, [family === null || family === void 0 ? void 0 : family.Person, person === null || person === void 0 ? void 0 : person.commonAllergies, profile === null || profile === void 0 ? void 0 : profile.commonAllergies]);
    useEffect(function () {
        if (lowFodmapDisabled && preferences.lowFodmap) {
            setPreferences(function (prev) { return (__assign(__assign({}, prev), { lowFodmap: false })); });
        }
    }, [lowFodmapDisabled, preferences.lowFodmap]);
    var toggleLowFodmap = useCallback(function () {
        if (lowFodmapDisabled) {
            return;
        }
        setPreferences(function (prev) { return (__assign(__assign({}, prev), { lowFodmap: !prev.lowFodmap })); });
    }, [lowFodmapDisabled]);
    var toggleLowBudget = useCallback(function () {
        setPreferences(function (prev) { return (__assign(__assign({}, prev), { lowBudget: !prev.lowBudget })); });
    }, []);
    var toggleLunchbox = useCallback(function () {
        setPreferences(function (prev) { return (__assign(__assign({}, prev), { lunchbox: !prev.lunchbox })); });
    }, []);
    var onSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 8, , 9]);
                    if (!confirmAlert) return [3 /*break*/, 2];
                    return [4 /*yield*/, confirmAlert()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!familyId) return [3 /*break*/, 4];
                    return [4 /*yield*/, updateFamilyPlanPreferences({
                            familyId: familyId,
                            lowFodmap: lowFodmapDisabled ? false : preferences.lowFodmap,
                            lowBudget: preferences.lowBudget,
                            lunchbox: preferences.lunchbox,
                            source: source,
                        })];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    console.debug('[useInputPlanPreferencesForm] familyId assente allo step Preferenze piano: salvataggio preferenze saltato.');
                    _a.label = 5;
                case 5:
                    if (!isNewFamilyMember) return [3 /*break*/, 7];
                    return [4 /*yield*/, updateProfile({}, onNext)];
                case 6:
                    _a.sent();
                    return [2 /*return*/];
                case 7:
                    onNext === null || onNext === void 0 ? void 0 : onNext();
                    return [3 /*break*/, 9];
                case 8:
                    error_1 = _a.sent();
                    console.debug('[useInputPlanPreferencesForm] Salvataggio preferenze piano interrotto.', error_1);
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); }, [
        confirmAlert,
        familyId,
        isNewFamilyMember,
        lowFodmapDisabled,
        onNext,
        preferences.lowBudget,
        preferences.lowFodmap,
        preferences.lunchbox,
        source,
        updateFamilyPlanPreferences,
        updateProfile,
    ]);
    var isDirty = useMemo(function () {
        return preferences.lowFodmap !== baselineRef.current.lowFodmap ||
            preferences.lowBudget !== baselineRef.current.lowBudget ||
            preferences.lunchbox !== baselineRef.current.lunchbox;
    }, [preferences]);
    return {
        preferences: preferences,
        toggleLowFodmap: toggleLowFodmap,
        toggleLowBudget: toggleLowBudget,
        toggleLunchbox: toggleLunchbox,
        lowFodmapDisabled: lowFodmapDisabled,
        onSubmit: onSubmit,
        confirmDisabled: !isDirty,
        isFamilyMember: isFamilyMember,
        isMinor: isMinor,
        labelsConjugationCondition: labelsConjugationCondition,
    };
};
